import {connect} from "react-redux";
import RescheduleLeadActivity from "./Reschedule";
import {bindActionCreators} from "redux";
import {rescheduleActivity} from "../../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    rescheduleActivityDetails:state.Dealer.rescheduleActivity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            rescheduleActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RescheduleLeadActivity);
